"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _classnames = _interopRequireDefault(require("classnames"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var images = ['https://staticintl.cloudcachetci.com/cms/backend-cms/ae98f69516f6460330af8cccde1dafbe16287561875934965.png', 'https://staticintl.cloudcachetci.com/cms/backend-cms/8deeb647c2c6ced892fe9badce16257616287561992455978.png', 'https://staticintl.cloudcachetci.com/cms/backend-cms/d589489602becf705c12c02931dbb31c16287562045919911.png', 'https://staticintl.cloudcachetci.com/cms/backend-cms/29c9479653bcf32a127e244414da66b616287562107744412.png'];
var BuyNowComponent = function BuyNowComponent(props) {
  var flexTitle = props.flexTitle,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b,
    onCallback = props.onCallback,
    layoutMode = props.layoutMode;
  var layoutNum = layoutMode ? 3 : 4;
  var compatibleArr = configuration && configuration.length % layoutNum ? __spreadArrays(configuration, new Array(layoutNum - configuration.length % layoutNum).fill({
    supplement: true
  })) : configuration;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'free-with-buy-now-default-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'free-with-buy-now-default__children'
  }, flexTitle && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-buy-now-default-container__children__container'
  }, compatibleArr.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      supplement = _a.supplement,
      content = _a.content,
      but_txt = _a.but_txt,
      but_href = _a.but_href,
      extendProps = _a.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list__container', {
        'flex-buy-now-default-container__children__container__list__container--mobile': supplement,
        'layout-three': layoutMode
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-buy-now-default-container__children__container__list'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'coupons-class-top'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: 'list__title'
    }, " ", title), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'lg-circle-class__buy_now_left',
      style: {
        left: '-1px',
        top: '83px'
      }
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'lg-circle-class__buy_now_right',
      style: {
        right: '-1px',
        bottom: '-24px'
      }
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'coupons-class'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__content',
      style: {
        backgroundImage: "url(" + images[Number(index) < 4 ? Number(index) % 4 : 3 - Number(index) % 4] + ")"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: '1',
        marginBottom: content ? '24px' : '0'
      },
      dangerouslySetInnerHTML: {
        __html: content || ''
      }
    }), !onCallback && but_href ? (/*#__PURE__*/_react["default"].createElement("a", __assign({
      className: 'list__a',
      href: but_href
    }, extendProps || {}), but_txt)) : but_txt && (/*#__PURE__*/_react["default"].createElement("div", __assign({
      className: 'list__a',
      onClick: function onClick() {
        onCallback && onCallback(item);
      }
    }, extendProps || {}), but_txt))))));
  })))));
};
BuyNowComponent.displayName = 'TCIBuyNowComponent';
var _default = exports["default"] = BuyNowComponent;